var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.445405 11.4138C0.160212 11.1321 0 10.7501 0 10.3518C0 9.95347 0.160212 9.57145 0.445405 9.28975L9.05118 0.791933C9.19151 0.64846 9.35938 0.534021 9.54498 0.455293C9.73058 0.376565 9.9302 0.335126 10.1322 0.333393C10.3342 0.331659 10.5345 0.369667 10.7215 0.445198C10.9084 0.520729 11.0783 0.63227 11.2211 0.773314C11.3639 0.914358 11.4769 1.08208 11.5534 1.26669C11.6299 1.4513 11.6684 1.64911 11.6666 1.84857C11.6649 2.04803 11.6229 2.24514 11.5432 2.42841C11.4634 2.61168 11.3475 2.77744 11.2022 2.91601L3.672 10.3518L11.2022 17.7876C11.4794 18.0709 11.6327 18.4503 11.6292 18.8442C11.6258 19.2381 11.4658 19.6148 11.1837 19.8934C10.9017 20.1719 10.5201 20.3299 10.1212 20.3333C9.72237 20.3367 9.33809 20.1853 9.05118 19.9117L0.445405 11.4138Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.21565449d89d94b9ac26d585c419b278.svg";
export { ForwardRef as ReactComponent };